<template>
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button @click="cerrarModal();">
          <ion-icon slot="icon-only"  name="arrow-back-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
      <ion-title>Imagen</ion-title>
      <ion-buttons slot="end">
        <ion-button @click="zoomIn()" color="warning" class="border border-warning rounded rounded-pill" style="font-weight: bold; width: 40px;">+</ion-button>
        <ion-button @click="zoomOut()" color="warning" class="border border-warning rounded rounded-pill" style="font-weight: bold; width: 40px;">-</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <div class="container-fluid" style="overflow: scroll;">
      <div class="m-2 border border-dark" :class="{'zoom1':zoomActual==1, 'zoom2':zoomActual==2, 'zoom3':zoomActual==3, 'zoom4':zoomActual==4, 'zoom5':zoomActual==5}">
        <img :src="imagen" class="img-fluid" style="width: 100%!important;"/>
      </div>
    </div>
  </ion-content>

  <ion-footer>
    <ion-grid>
      <ion-row>
        <ion-col>
            <ion-button @click="cerrarModal()" color="danger" shape="round" expand="block">
                <ion-label>CERRAR</ion-label>
            </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-footer>
</template>

<script>
import { modalController, IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow, IonGrid, IonLabel/*, IonImg*/ } from '@ionic/vue';
import { defineComponent } from 'vue';
import { addIcons        } from 'ionicons';
import { arrowBackOutline, trashOutline, settingsOutline } from 'ionicons/icons';

export default defineComponent({
  name: 'ModalImagen',
  props: {
    imagen      : String,
    modal       : Object
  },
  components: { IonContent, IonFooter, IonHeader, IonTitle, IonToolbar, IonButtons, IonButton, IonIcon, IonCol, IonRow, IonGrid, IonLabel/*, IonImg*/ },
  data(){
    return {
      cargando    : true,
      zoomActual  : 1
    }
  },
  created() {
    addIcons({
      'arrow-back-outline'  : arrowBackOutline,
      'trash-outline'       : trashOutline,
      'settings-outline'    : settingsOutline
    });
  },
  methods:{
    async cerrarModal(dato=null){
      modalController.dismiss(dato);
    },

    async zoomIn(){
      if(this.zoomActual < 5){
        this.zoomActual+=1;
      }
    },

    async zoomOut(){
      if(this.zoomActual > 1){
        this.zoomActual-=1;
      }
    }
  }
});
</script>

<style scoped>
.primary{
  color: #3880ff;
}

.rounded-border {
  border:2px solid black;
  color:black; 
  padding:6px; 
  border-radius:15px; 
  margin-right:2px;
}

.cards {
  min-height: 150px;
  border-radius: 15px; 
  margin: 0;
  /* background-color: white !important; */
  border: 2px solid black !important;
}

.fondo{
  /* background-color: white !important; */
  height: 100% !important;
}

.zoom1 {
  width: 350px !important;
}
.zoom2 {
  width: 650px !important;
}
.zoom3 {
  width: 950px !important;
}
.zoom4 {
  width: 1250px !important;
}
.zoom5 {
  width: 1550px !important;
}
</style>